<template>
  <div
    class="
      banner
      u-padding-left-6x u-padding-right-4x u-padding-y-3x u-flex u-between
    "
  >
    <div class="banner__container u-flex u-align-center">
      <SvgIcon
        name="info-bubble"
        class="u-color-primary-text-inverted u-margin-right-2x"
      />
      <span
        class="u-strong u-color-primary-text-inverted u-margin-right-1x"
        v-html="$t('common.deprecationBanner.title')"
      >
      </span>
      <span
        class="u-color-primary-text-inverted"
        v-html="$t('common.deprecationBanner.description')"
      ></span>
    </div>
  </div>
</template>

<script lang="ts">
import { SvgIcon } from '@te/cdev-design-system';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { SvgIcon }
});
</script>

<style lang="scss" scoped>
$banner-color: #0d274d;
$banner-height: 56px;

.banner {
  min-height: $banner-height;
  background-color: $banner-color;
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1000;

  &__container {
    flex-wrap: wrap;

    [dir='rtl'] & {
      margin-right: spacing('6x');
    }
  }
}
</style>
